'use strict';

var _                				= require('underscore');
var $                				= require('jquery');
var Core             				= require('../core/core.js');
var Velocity								= require('velocity-animate');
var DashboardListComponents = require('./dashboard__listcomponents.js');
var DashboardButton					= require('./dashboard__button.js');

/**
 * Creates a Dashboard to view other projects
 *
 * @class
 */

class Dashboard extends Core {

	_defaults() {
		return {
			target: 'body',
			fields: {}
		};
	}

	constructor(options) {
		super(options);

		this.template = `
			<div class="editor__dashboard js-editor__dashboard">
				<div class="editor__dashboard__overlay js-editor__dashboard__overlay"></div>
        <div class="editor__dashboard__container">
					<div class="editor__dashboard__dialog js-editor__dashboard__dialog">

						<div class="editor__dashboard__header">
							<div class="editor__dashboard__header__title">
								<div class="editor__dashboard__header__title__icon"></div>
								<div class="editor__dashboard__header__title__text js-editor__dashboard__header__title__text"></div>
							</div>
							<div class="editor__dashboard__header__content js-editor__dashboard__header__content">
								<a target="_blank" href="" class="editor__dashboard__header__link js-editor__dashboard__header__link"></a>
								<div class="editor__dashboard__header__btnGroup js-editor__dashboard__header__btnGroup"></div>
							</div>
							<div class="editor__dashboard__header__closeBtn js-editor__dashboard__header__closeBtn">
								&times;
							</div>
						</div>

						<div class="editor__dashboard__content js-editor__dashboard__content">
						</div>

					</div>
				</div>
      </div>
		`;

		super.render();

		$('.js-editor__dashboard__overlay', this.$el).on('mousedown', this._overlayClicked);
		$('.js-editor__dashboard__header__closeBtn', this.$el).on('mousedown', this._closeBtnClicked);
	}

	/**
	 * Add a title in the menu
	 * @param {String} title - A string with the desired title
	 * @returns none
	 */

	addTitle(title){
		$('.js-editor__dashboard__header__title__text', this.$el).text(title);
	}

	setReturnLink(text, url) {
		$('.js-editor__dashboard__header__link', this.$el).text(text)
		.attr("href", url);
	}

	addHeaderButton(text) {
		return new DashboardButton({
			target: $('.js-editor__dashboard__header__btnGroup', this.$el),
			fields: {
				"text": text,
			}
		});
	}

	addListComponent() {
		return new DashboardListComponents({
			target: $('.js-editor__dashboard__content', this.$el),
			fields: {}
		});
	}

	quickHide() {
		this.$el.hide();
		$('.js-editor__dashboard__dialog', this.$el).css('opacity', 0);
	}

	hide() {
		var $self = this.$el;

		Velocity($('.js-editor__dashboard__dialog', this.$el), "stop");
		Velocity($('.js-editor__dashboard__dialog', this.$el), {
			'opacity': 0
		},{
			duration: 350,
			easing: "easeInOut",
			complete: function() {
				$self.hide();
			}
		});

	}

	show(completeCallBack) {
		var $self = this.$el;

		this.$el.show();
		Velocity($('.js-editor__dashboard__dialog', this.$el), "stop");
		Velocity($('.js-editor__dashboard__dialog', this.$el), {
			'opacity': 1.0
		},{
			duration: 350,
			easing: "easeInOut",
			complete: function() {
				if (typeof completeCallBack === 'function') {
					completeCallBack();
				}
			}
		});

	}

	_overlayClicked(e) {
		e.preventDefault();
		$(e.currentTarget).trigger('Cioui:DashboardOverlay:clicked');
	}

	_closeBtnClicked(e) {
		e.preventDefault();
		$(e.currentTarget).trigger('Cioui:DashboardCloseButton:clicked');
	}

}
module.exports = Dashboard;
